import { FC, useEffect, useState } from 'react'
import { Box, Button, Paper, Typography, Slide, Stack } from '@mui/material'
import CookieIcon from '@mui/icons-material/Cookie'

const STORAGE_KEY = 'originei.cookies.aceito'

/**
 * Banner LGPD de cookies. Como a Originei usa apenas cookies estritamente
 * necessários (autenticação/sessão), oferecemos apenas a opção "Entendi" —
 * não há rastreio publicitário ou analytics que demande consentimento granular.
 */
export const CookieBanner: FC = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const aceito = localStorage.getItem(STORAGE_KEY)
    if (!aceito) {
      // pequeno delay pra não bater visualmente com o login carregando
      const t = setTimeout(() => setVisible(true), 600)
      return () => clearTimeout(t)
    }
    // Sem timer agendado não há o que limpar — retorno explícito para o efeito ter o
    // mesmo contrato nos dois caminhos.
    return undefined
  }, [])

  const aceitar = () => {
    localStorage.setItem(STORAGE_KEY, new Date().toISOString())
    setVisible(false)
  }

  return (
    <Slide direction="up" in={visible} mountOnEnter unmountOnExit>
      <Paper
        elevation={8}
        sx={{
          position: 'fixed',
          bottom: 16,
          left: 16,
          right: 16,
          maxWidth: 720,
          mx: 'auto',
          p: 2.5,
          zIndex: 1400,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
          <CookieIcon sx={{ fontSize: 36, color: 'primary.main', flexShrink: 0 }} />
          <Box sx={{ flex: 1 }}>
            <Typography variant="body2" fontWeight={600} gutterBottom>
              Usamos apenas cookies essenciais
            </Typography>
            <Typography variant="caption" color="text.secondary">
              O portal utiliza somente cookies estritamente necessários para autenticação e sessão.
              Não há cookies de rastreio publicitário ou analytics. Saiba mais na nossa{' '}
              <a href="/privacidade" style={{ color: 'var(--brand-primary)', textDecoration: 'underline' }}>
                Política de Privacidade
              </a>
              .
            </Typography>
          </Box>
          <Button variant="contained" onClick={aceitar} sx={{ flexShrink: 0 }}>
            Entendi
          </Button>
        </Stack>
      </Paper>
    </Slide>
  )
}
